import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeSourceType } from "../Entity/TreeNodeSourceType";
import { ListView } from "../../../Data/ListView";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSourceList extends Art57NodeList {
  constructor(injector: Injector, parent: Art57Node) {
    super(injector, new ListView(), 'Sources ({param})');
    this.parent = parent;
    this.labelNodeName = 'Sources';
    this.expanded = true;
  }

  override refreshLabel(): void {
    this.label = this.labelTemplate.replace(
      '{param}',
      this.getLabelParamFromChildren()
    );
  }

  override createChildTemplate(params: any): Art57Node[] | null {
    let nodeCreated = new TreeNodeSourceType(this.ioc!, this);
    if ((params.operationType === 1) && (this.ioc!.get(Art57Section).isCreateAndSendProductSection() || this.ioc!.get(Art57Section).isMedicinalProductSection())) { // only operationtype insert has localnumber
      nodeCreated.data.model.localnumber = this.ioc!.get(LookupGetService).getLocalNumber();
    }
    this.children?.push(nodeCreated);
    this.refreshLabel();
    return [nodeCreated];
  }

  override getMessage(): any {
    let sources: any[] = [];
    this.children?.forEach((node) => {
      let source = node as TreeNodeSourceType;
      let art57Message = source.getMessage();
      if (art57Message != null) {
        sources.push(art57Message);
      }
    });

    if (this.children!.length > 0) {
      return { sources: { source: sources } };
    } else {
      return;
    }
  }

  override getHeaders(): string[] {
    return ['EV Code', 'Operation Type', 'Source Name'];
  }

  override cloneNode(newParent: Art57Node): Art57Node|undefined {
    let clonedNode: TreeNodeSourceList = new TreeNodeSourceList(
      this.ioc!,
      newParent
    );

    this.children?.forEach((child) => {
      let childToClone = child as Art57Node;
      let clonedChildren = childToClone.cloneNode(clonedNode);
      if (clonedChildren) {
          clonedNode.children?.push(clonedChildren);
          clonedChildren.refreshLabel();
      }
    });

    clonedNode.refreshLabel();
    clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning || environment.userPreferences.alwaysAutoexpandNodes)


    return clonedNode;
  }
}